import { TemplateType } from './template-type';
import { VirtualGridRow } from './virtual-grid-row';

/**
 * VirtualGridGroup is used to display grouped data in the grid.
 *
 * The VirtualGridGroup interface allows the host application to
 * provide a tree of grouped data, allowing multiple levels of grouping
 */
export interface VirtualGridGroup {
  /**
   * grouping name to be used in he default grouping template.
   * Usually represents the field by which the grouping was performed
   */
  label?: string;

  /**
   * data to be displayed next to label in the default grouping template.
   * data can be any type, when a custom template is provided
   */
  data?: any;

  /**
   * list of labels to be used
   * if present, the label and data attributes are ignored
   */
  labels?: { label?: string; data: any }[];

  /**
   * custom template to be used in the grouping header
   *
   * if string, {{LABEL}} and {{DATA}} will be replaced by
   * label and data respectively
   */
  groupHeaderTemplate?: TemplateType | string;

  /**
   * indicates if the grouping data is collapsed in the grid
   */
  collapsed?: boolean;

  /**
   * indicates if all its children items are selected
   */
  selected?: boolean;

  /**
   * items under this grouping level.
   *
   * can also be an array of VirtualGridGroup for a nested grouping level
   */
  items: Array<VirtualGridRow | any> | Array<VirtualGridGroup>;

  /**
   * grouping nested level
   * numbers grow when grouping level getts deep
   */
  level?: number;

  /**
   * id to be used in the html template ID attribute
   */
  id?: string;
}

export function isVirtualGridGroup(obj: any): boolean {
  return !!(obj && 'data' in obj && 'items' in obj);
}
